import { join, words } from "lodash";

export default function getDefaultImage({ name }) {
  return `https://ui-avatars.com/api/?background=random&name=${join(
    words(name),
    "+"
  )}`;
}
